import { render, staticRenderFns } from "./StockProductLayout.vue?vue&type=template&id=648e5926&scoped=true&"
import script from "./StockProductLayout.vue?vue&type=script&lang=js&"
export * from "./StockProductLayout.vue?vue&type=script&lang=js&"
import style0 from "./StockProductLayout.vue?vue&type=style&index=0&id=648e5926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e5926",
  null
  
)

component.options.__file = "StockProductLayout.vue"
export default component.exports